import { render } from "./MaoButton.vue?vue&type=template&id=1a54a0c9&scoped=true"
import script from "./MaoButton.vue?vue&type=script&lang=js"
export * from "./MaoButton.vue?vue&type=script&lang=js"

import "./MaoButton.vue?vue&type=style&index=0&id=1a54a0c9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a54a0c9"]])

export default __exports__